import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PreviewLetter } from '../../../../shared/components/PreviewLetter'
import { SubmitSuccessfulPage } from '../../../../shared/pages/SubmitSuccessfulPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { SubmitSuccessProps } from '../../../../shared/types/toolTypes'
import { ToolFeedbackFlow, ToolFeedbackThankYouFlow } from '../../pageFlowData'
import { composeEmailBody } from './composeEmailBody'
import { feedbackData } from './data'

export const SubmitSuccessful: FunctionComponent<SubmitSuccessProps> = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { emailSent, user },
    issue,
    product,
    retailer,
    toolFeedback: { showFeedback },
  } = state

  const { body, imgObj, title } = feedbackData

  const data = composeEmailBody({ retailer, product, issue, user })

  const standFirstCopy = emailSent
    ? `A copy of your complaint has been sent to ${user.emailAddress}`
    : 'Due to an error, we were unable to send your email. However, you can get a copy of your complaint letter below'

  const handleStepChoice = (id: string) => {
    if (id === 'feedback-yes') {
      return { step: ToolFeedbackFlow.STEP }
    }

    return { step: ToolFeedbackThankYouFlow.STEP }
  }

  const handleDispatch = (id: string) => {
    const { step } = handleStepChoice(id)
    dispatch({ type: 'UPDATE_STEP', data: step })
  }

  const handleSubmit = (id: string) => {
    handleDispatch(id)
  }

  return (
    <div data-testid="submit-successful">
      <SubmitSuccessfulPage
        feedbackBody={body}
        feedbackImgObj={imgObj}
        feedbackTitle={title}
        handleSubmit={handleSubmit}
        letterBody={data.body}
        letterTitle="Your complaint email"
        list={[
          `Send the letter to ${retailer.name} via email or post.`,
          `Give ${retailer.name} 14 days to respond.`,
          `Don't be fobbed off! Under the Consumer Rights Act 2015 it is the responsibility of ${retailer.name} to put the situation right. Don't let them tell you they can't help as you're out of warranty or blame the manufacturer.`,
        ]}
        showFeedback={showFeedback}
        standFirst={standFirstCopy}
        title="Your next steps"
      >
        <PreviewLetter data={data} />
      </SubmitSuccessfulPage>
    </div>
  )
}
